"use client";

import type { ReactNode } from "react";

export const infoCardClassName =
  "rounded-2xl border border-slate-200 bg-white p-6 dark:border-slate-800 dark:bg-slate-900";

export const infoCardLabelClassName =
  "text-sm font-semibold uppercase text-primary-700 dark:text-primary-300";

export const infoCardIntroClassName = "mt-1 text-slate-500 dark:text-slate-400";

export const infoCardListClassName = "mt-4 list-none space-y-3";

export const infoCardLinkClassName =
  "mt-4 inline-block text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700 dark:text-primary-300 dark:hover:text-primary-100";

type InfoCardProps = {
  children: ReactNode;
  className?: string;
  testId?: string;
};

export function InfoCard({ children, className = "", testId }: InfoCardProps): JSX.Element {
  const mergedClassName = `${infoCardClassName} ${className}`.trim();

  return (
    <div className={mergedClassName} data-testid={testId}>
      {children}
    </div>
  );
}
